import { IconButton, Link, Typography } from "@mui/material";
import {
  ArrowRight,
  FileTextIcon,
  Lightbulb,
  MessageSquare,
  X,
} from "lucide-react";
import FlexBox from "components/common/FlexBox";
import { ReactComponent as Sparkles } from "../../../icons/Advisor/Sparkles.svg";
import { useSearchParams } from "react-router-dom";

const iconStyle = {
  size: 20,
  style: { flexShrink: 0, marginRight: "8px", verticalAlign: "middle" },
} as const;

export const DocumentAction = ({
  message,
  url,
}: {
  message: string;
  url: string;
}) => {
  return (
    <Link href={url}>
      <FileTextIcon {...iconStyle} />
      {message}
    </Link>
  );
};
export const MessageAction = ({ message }: { message: string }) => {
  const [, setSearchParams] = useSearchParams();
  return (
    <Link
      sx={{ cursor: "pointer" }}
      onClick={() => {
        setSearchParams((p) => {
          p.set("textMessage", message);
          return p;
        });
      }}
    >
      <MessageSquare {...iconStyle} />"{message}"
    </Link>
  );
};

export const LinkAction = ({
  message,
  url,
  icon = <ArrowRight />,
}: {
  message: string;
  url: string;
  icon?: React.ReactNode;
}) => {
  return (
    <Link href={url} sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
      {icon}
      {message}
    </Link>
  );
};

export const TaskAction = ({
  message,
  url,
}: {
  message: string;
  url: string;
}) => {
  return (
    <Link href={url}>
      <Lightbulb {...iconStyle} />
      {message}
    </Link>
  );
};

export default ({
  title,
  description,
  action,
  children,
  onClose,
  icon = <Sparkles />,
}: {
  title: string;
  description: React.ReactNode;
  action: React.ReactNode;
  children?: React.ReactNode;
  onClose: () => void;
  icon?: React.ReactNode;
}) => (
  <FlexBox
    variant="contained"
    direction="column"
    gap="8px"
    sx={{ position: "relative" }}
  >
    <FlexBox gap="8px">
      {icon}
      <Typography variant="bodyHeavy">{title}</Typography>
    </FlexBox>
    <Typography variant="body">{description}</Typography>
    {action}
    {children}
    <IconButton
      size="small"
      onClick={onClose}
      sx={{ position: "absolute", top: 16, right: 16 }}
    >
      <X size={20} color="#8E9598" />
    </IconButton>
  </FlexBox>
);
